import React from 'react'
import { Flex, Box, Image } from '@chakra-ui/react'
import { CloseIcon } from '@blueprinthq/joy'
import { useStoreState } from 'easy-peasy'

import WhiteLogo from '../../images/brand/white_logo.svg'
import { Mic, MicOff } from '../../components/icons'
import { MinimizeIcon, ExpandIcon, BIcon } from '@icons'
import { useExperienceManager, useAudioCapture } from '@hooks'
import { ArrowLeft } from '@components/icons'
import { useHistory } from 'react-router-dom'

const MinimizedNavBar = () => {
  const { toggleIsExtensionMinimized } = useExperienceManager()
  const { isMuted, toggleMute } = useAudioCapture()
  const { audioLevel } = useStoreState(state => state.volume)

  return (
    <Flex
      height="100%"
      justifyContent="space-between"
      alignItems="center"
      m="0 20px"
    >
      <Box id="bp-copilot-header" _hover={{ cursor: 'move' }}>
        <BIcon />
      </Box>
      <Flex
        backgroundColor="white"
        borderRadius="50px"
        width="40px"
        height="40px"
        justifyContent="center"
        alignItems="center"
        _hover={{ cursor: 'pointer' }}
        onClick={toggleMute}
      >
        {isMuted ? <MicOff /> : <Mic dy={1 - audioLevel} />}
      </Flex>
      <Box
        _hover={{ cursor: 'pointer' }}
        onClick={() => toggleIsExtensionMinimized()}
      >
        <ExpandIcon />
      </Box>
    </Flex>
  )
}

export const NavBar = ({
  hasStartedRecording = false,
  showBackButton = false
}: {
  hasStartedRecording?: boolean
  onSessionEnd?: () => void
  showBackButton?: boolean
}) => {
  const history = useHistory()
  const {
    isExtensionMinimized,
    toggleIsExtensionMinimized
  } = useExperienceManager()

  if (isExtensionMinimized) {
    return <MinimizedNavBar />
  }

  return (
    <Flex justifyContent="space-between" alignItems="center" p={'20px'}>
      <Box
        w="48px"
        visibility={showBackButton ? 'visible' : 'hidden'}
        onClick={() => history.push('/extension/start-session')}
        _hover={{ cursor: 'pointer' }}
      >
        <ArrowLeft fill="white" />
      </Box>
      <Image
        id="bp-copilot-header"
        src={WhiteLogo}
        _hover={{ cursor: 'move' }}
      />
      <Flex w="48px" justifyContent="flex-end">
        {hasStartedRecording && (
          <Box
            _hover={{ cursor: 'pointer' }}
            onClick={() => toggleIsExtensionMinimized()}
          >
            <MinimizeIcon />
          </Box>
        )}
        {!hasStartedRecording && (
          <Box
            _hover={{ cursor: 'pointer' }}
            // eslint-disable-next-line
            onClick={() => parent.postMessage({ type: 'BP_CLOSE' }, '*')}
            ml="xxsmall"
          >
            <CloseIcon fill="white" />
          </Box>
        )}
      </Flex>
    </Flex>
  )
}
